import styled from 'styled-components';

export const SvodButtonsStyled = styled.div`
  position: relative;
`;
